import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

export default function AIPanelLayout({children}) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTabs-flexContainer": {
            justifyContent: "flex-end",
          },
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            sx: {
              display: "none",
            },
          }}
          sx={{
            height: "26px",
            minHeight: "26px",
            "& .MuiButtonBase-root": {
              fontSize: "12px",
              fontWeight: 400,
              textTransform: "none",
              backgroundColor: "#BAB7B7",
              borderRadius: "10px 10px 0px 0px",
              marginRight: "3px",
              height: "26px !important",
              width: "130px!important",
              color: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "#61D5A9",
              color: "white !important",
            },
          }}
        >
              <Tab
                sx={{ minHeight: "26px", height: "26px" }}
                label={"Status"}
                {...a11yProps(0)}
              />
        </Tabs>
      </Box>
        <Box sx={{ padding: "18px" }}>{children}</Box>
    </Box>
  );
}
